import { useAuthActions } from "@convex-dev/auth/react";
import { useQuery } from "convex/react";
import { useState } from "react";
import { Link } from "react-router";
import { Navbar } from "@repo/ui";
import { api } from "../../../../convex/_generated/api";
import { LayoutDashboard, Megaphone } from "lucide-react";

export function AdminNavbar() {
  const { signOut } = useAuthActions();
  const user = useQuery(api.auth.currentUser);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  // Extraction du nom - utilise email comme fallback
  const displayName = user?.name ?? user?.email ?? "Administrateur";
  const initials = displayName
    .split(" ")
    .map((n: string) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await signOut();
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <Navbar
      title="Portail Admin"
      userInfo={{
        displayName,
        subtitle: "Administration",
        initials: initials || "AD",
      }}
      onLogout={handleLogout}
      isLoggingOut={isLoggingOut}
      centerContent={
        <nav className="flex items-center gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-muted/50 transition-colors"
          >
            <LayoutDashboard className="h-4 w-4" />
            <span className="text-sm">Parcours</span>
          </Link>
          <Link
            to="/campagnes"
            className="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-muted/50 transition-colors"
          >
            <Megaphone className="h-4 w-4" />
            <span className="text-sm">Campagnes</span>
          </Link>
        </nav>
      }
    />
  );
}
